<template>
  <div class="row">
    <div class="columns">
      <div class="panel">
        <div class="small-10 medium-8 large-6 small-centered medium-centered large-centered columns text-center">
          <i class="fa fa-mobile fa-5x"></i>

          <h2>SMS</h2>

          <p>The ClassForKids SMS feature sends a text along with every invoice you send. An additional SMS reminder increases the chances of parents seeing their invoice. The best bit is that all SMS invoice messages are free!</p>

          <ToggleWithLabel feature="sms" setting="sms" :disable-if-toggled-on="false"/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleWithLabel from "./ToggleWithLabel";

export default {
  name: "Sms",
  data() {
    return {};
  },
  components: {
    ToggleWithLabel
  }
};
</script>

<style scoped>
i {
  color: #0c3a54;
}
</style>